import { Loading03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const ProcessingIcon = () => (
  <div className="size-16 shrink-0 bg-warning-50 rounded-full flex items-center justify-center mb-6 mx-auto">
    <HugeiconsIcon
      icon={Loading03Icon}
      size={24}
      className="text-warning-600"
    />
  </div>
);
